import moneyString from '../moneyString.js'

function generateCartLineForPrepaidGratuities (price, cartId) {
  return {
    'cart_id': cartId,
    'value': moneyString(price),
    'product': {
      'id': 'gratuaties',
      'name': 'Gratuities',
      'category': 'Extras/Gratuities',
      'quantity': '1',
      'value': moneyString(price),
    },
  }
}

function createCartLinesForPrePaidGratuities (prepaidGratuities, cartId) {
  return prepaidGratuities.reduce( (cartLines, gratuity) => {
    cartLines.push(generateCartLineForPrepaidGratuities(gratuity.amount, cartId))
    return cartLines
  }, [])
}


function arrayDiff (a, b) {
  return a.filter(i => b.indexOf(i) < 0)
}

export default {
  eventsFor: (oldState, newState) => {

    function prepaidGratuitiesAddToCartEvent (price) {
      return {
        'event': 'addToCart',
        'cart_lines': [generateCartLineForPrepaidGratuities(price, newState.cart.cartId)],
      }
    }

    function prepaidGratuitiesRemoveFromCartEvent (price) {
      return {
        'event': 'removeFromCart',
        'cart_lines': [generateCartLineForPrepaidGratuities(price, newState.cart.cartId)],
      }
    }

    const events = []

    if ( (oldState && oldState.cart.prepaidGratuities.length) || (newState && newState.cart.prepaidGratuities.length)) {
      const oldGratuityPrices = oldState.cart.prepaidGratuities
        .map(gratuity => gratuity.amount)
      const newGratuityPrices = newState.cart.prepaidGratuities
        .map(gratuity => gratuity.amount)

      if (oldGratuityPrices.length > newGratuityPrices.length) {
        const removedPrice = arrayDiff(oldGratuityPrices, newGratuityPrices)[0] || oldGratuityPrices[0]
        events.push( prepaidGratuitiesRemoveFromCartEvent(removedPrice) )
      } else if (oldGratuityPrices.length < newGratuityPrices.length) {
        const addedPrice = arrayDiff(newGratuityPrices, oldGratuityPrices)[0] || newGratuityPrices[0]
        events.push( prepaidGratuitiesAddToCartEvent(addedPrice) )
      }
    }

    return events
  },
  cartLinesFor (currentState) {
    return createCartLinesForPrePaidGratuities(currentState.cart.prepaidGratuities, currentState.cart.cartId)
  },
}